import React, { useEffect } from 'react';
import { Dayjs } from 'dayjs';
import { Box } from '@mos-cat/ds';
import { VisuallyHidden } from 'reakit';

import {
  getCalendarFirstDate,
  getCalendarLastDate,
  getWeeksCount,
  getWeekStartDate,
} from '../../../../../helpers/date';
import { SHORT_DAYS_NAMES, DAYS_NAMES } from '../../../../../constants/date';
import Week from './Week';
import { sendStats, STATS_EVENTS } from '../../../../../helpers/sendStats';

type Props = {
  dateFrom: Dayjs;
  dateTo: Dayjs;
  period: string;
};
export default function DaysCalendar({ dateFrom, dateTo, period }: Props) {
  const calendarFirstDate = getCalendarFirstDate(dateFrom);
  const calendarLastDate = getCalendarLastDate(dateTo);
  const weeksCount = getWeeksCount(calendarFirstDate, calendarLastDate);

  useEffect(function sendStatsOnMount() {
    sendStats(STATS_EVENTS.CALENDAR);
  }, []);

  return (
    <Box as="table" role="grid" styles={{ borderCollapse: 'collapse' }}>
      <VisuallyHidden as="caption">
        Календарь за период:
        {period}
      </VisuallyHidden>
      <Box as="thead">
        <Box as="tr">
          {SHORT_DAYS_NAMES.map((dayName, day) => (
            <Box
              key={dayName}
              as="th"
              scope="col"
              abbr={DAYS_NAMES[day]}
              aria-label={DAYS_NAMES[day]}
              color="calendarDayOfWeek"
              pb="calendarDayNamesPb"
              styles={{
                fontSize: 'fs-14',
                lineHeight: 'calendarBtnLineHeight',
                fontWeight: 'normal',
              }}
            >
              {dayName}
            </Box>
          ))}
        </Box>
      </Box>
      <Box as="tbody">
        {Array.from({ length: weeksCount }).map((_, week) => {
          const startDate = getWeekStartDate(calendarFirstDate, week);
          return (
            <Week
              key={startDate.format()}
              startDate={startDate}
              dateFrom={dateFrom}
              dateTo={dateTo}
            />
          );
        })}
      </Box>
    </Box>
  );
}
